import { makeAutoObservable } from 'mobx';
import { IValidatedInputLibrary } from '../IValidatedInputLibrary';

export class TextInputLibrary implements IValidatedInputLibrary
{
	constructor(pattern: string, maxLen: number, isRequired: () => boolean, onValidate?: (value: string)=> boolean)
	{
		this.Pattern = pattern;
		this.MaxLength = maxLen;
		this.IsRequired = isRequired;
		this.OnValidate = onValidate;

		makeAutoObservable(this, {}, { autoBind: true });
	}

	/** Содержимое поля ввода */
	public Value: string | undefined = undefined;
	public setValue(value: string | undefined)
	{
		if (value === undefined) this.Value = value;
		else this.Value = value.trim();
		this.IsConfirmed = (value === this.ConfirmedValue);
	}

	/** Валидность поля ввода */
	public IsValid: boolean = true;
	public setIsValid(value: boolean) { this.IsValid = value; }

	/** Подтвержденность поля ввода */
	public IsConfirmed: boolean = false;

	/** Максимальная длина */
	public MaxLength: number

	/** Подтвержденноое значение поля ввода */
	public ConfirmedValue: string | undefined = undefined;
	public setConfirmedValue(value: string | undefined) { this.ConfirmedValue = value; }

	/** Регулярное выражение для проверки */
	public Pattern: string;

	/** Необходимость поля ввода */
	public IsRequired: () => boolean;

	/** Валидация */
	public OnValidate?: (value: string) => boolean;

	/** Доступность поля ввода */
	public IsDisabled: boolean = false;
	public setIsDisabled(value: boolean) { this.IsDisabled = value; }

	/** Валидация */
	public Validate(onlyCheck?: boolean): boolean
	{
		if (this.IsDisabled)
		{
			if (onlyCheck) return true;
			this.IsValid = true;
			return this.IsValid;
		}

		if (this.Value === undefined || this.Value.trim().length === 0)
		{
			if (this.IsRequired())
			{
				if (onlyCheck) return false;
				this.IsValid = false;
				return this.IsValid;
			}

			if (onlyCheck) return true;
			this.IsValid = true;
			return this.IsValid;
		}

		if (this.Value.trim().length > this.MaxLength)
		{
			if (onlyCheck) return false;
			this.IsValid = false;
			return this.IsValid;
		}

		const r: RegExp = new RegExp(this.Pattern, "gim");
		if (!r.test(this.Value))
		{
			if (onlyCheck) return false;
			this.IsValid = false;
			return this.IsValid;
		}

		if (this.OnValidate && !this.OnValidate(this.Value))
		{
			if (onlyCheck) return false;
			this.IsValid = false;
			return this.IsValid;
		}

		if (onlyCheck) return true;
		this.IsValid = true;
		return this.IsValid;
	}
}
